import { customElement } from 'lit/decorators.js';
import { WEB_COMPONENT_POLICY_PANEL_APPLICATION_CONTROL_TARGETS_TABLE } from '../../../../../../../../webcomponents.constants';
import { GzPolicyUiSettingsTableWebComponent } from '../../../../../../../common/policyPanel/uiSettings/gridTemplate/gridComponents/dataTable';
import { getTableColumns, isContextAvailable } from './grid-config';
import { html, TemplateResult } from 'lit';
import { GRID_ITEM_FORM_ID } from '../../../../../../../common/policyPanel/uiSettings/gridTemplate/gridComponents/base/component/GzPolicyUiSettingsBaseGrid';
import {
  ApplicationControlRuleTargetsProcesses,
  ApplicationControlTargetProcessType,
} from '@nirvana/shared/dtos/types/policies/common';
import { RequiredValidator } from '../../../../../../../../ui/gzForm/validators/required.validator';
import { translateFn } from '../../../../../../../../utils/translator.helper';
import { CustomizableValidator } from '../../../../../../../../ui/gzForm/validators/customizable.validator';
import { matchValidatorsByType } from '../utils/validators';
import { GzFormFieldWebComponent } from '../../../../../../../../ui/gzForm/formField';

@customElement(WEB_COMPONENT_POLICY_PANEL_APPLICATION_CONTROL_TARGETS_TABLE)
export class GzApplicationControlTargetsTableWebComponent extends GzPolicyUiSettingsTableWebComponent<
  ApplicationControlRuleTargetsProcesses,
  ApplicationControlRuleTargetsProcesses
> {
  protected hasReorderRowAction = false;
  private editedType: ApplicationControlTargetProcessType;

  // bind this for access to edited row index
  protected columns = getTableColumns([
    RequiredValidator(translateFn('Required field')),
    CustomizableValidator((value: string) => matchValidatorsByType(this.editedType, value)),
  ]);

  protected renderGridItemForm(): TemplateResult {
    return html` <gz-policy-panel-application-control-target-item
      id="${GRID_ITEM_FORM_ID}"
    ></gz-policy-panel-application-control-target-item>`;
  }

  protected onEditRowEnabled(event: CustomEvent) {
    super.onEditRowEnabled(event);
    this.editedType = event.detail.item.type;

    const editedFields = this.gridComponent.shadowRoot?.querySelectorAll('.edit-form-field');
    if (editedFields) {
      editedFields.forEach((field: GzFormFieldWebComponent) => {
        if (field.id.split('-')[0] === 'context') {
          field.disabled = !isContextAvailable(this.editedType);
        }
      });
    }
  }
}
